@if (icon) {
  <button
    mat-button
    [matMenuTriggerFor]="languageMenu"
    appTrackClick="language-selector-btn"
  >
    <div class="text-dark d-flex align-items-center gap-1">
      <mat-icon>language</mat-icon>
      <ng-content></ng-content>
    </div>
  </button>
} @else {
  <button
    mat-flat-button
    color="primary"
    [matMenuTriggerFor]="languageMenu"
    appTrackClick="language-selector-btn"
  >
    {{ currentLanguage }}
  </button>
}
<ng-template #text>
  <button mat-flat-button color="primary" [matMenuTriggerFor]="languageMenu">
    {{ currentLanguage }}
  </button>
</ng-template>
<mat-menu #languageMenu="matMenu">
  @for (language of languages; track language) {
    <button
      mat-menu-item
      (click)="setLanguage(language)"
      appTrackClick="language-selector-{{ language }}-btn"
    >
      {{ languageMap[language] }}
    </button>
  }
</mat-menu>
